export default "__VITE_ASSET__8c55hoil__"